const enum NaasEvent {
	INIT = 'dxnav-init',
	OVERLAY_OPEN = 'dxnav-overlay-open',
	OVERLAY_CLOSE = 'dxnav-overlay-close',
	OVERLAY_CLOSED = 'dxnav-overlay-closed',
	RETAILER_OVERLAY_OPEN = 'dxnav-retailer-overlay-open',
	RETAILER_OVERLAY_CLOSE = 'dxnav-retailer-overlay-close',
	VEHICLE_DROPDOWN_OPEN = 'dxnav:VehicleDropdownInitialOpen',
	LANGUAGE_SELECTOR_OPEN = 'dxnav-language-selector-overlay-open',
}

export { NaasEvent };
